import React from "react";

import { twMerge } from "tailwind-merge";

export const Headline4: React.FC<React.ComponentProps<"h4">> = ({
  children,
  className,
  ...props
}) => {
  return (
    <h4
      className={twMerge(
        `h-[30px] text-lg font-semibold text-gray-800 sm:text-base`,
        className,
      )}
      {...props}
    >
      {children}
    </h4>
  );
};
// className=""
